// extracted by mini-css-extract-plugin
export default {"tabs":"Menu_tabs__lpyR0"};